<template>
  <tr
    class="poppins text-gray-400 text-xs"
    v-for="[fieldKey, field] of fields"
    :key="fieldKey"
  >
    <th align="left" class="font-bold h-8 leading-8 w-32">
      {{ field.name }}
    </th>
    <th
      v-for="(value, idx) of field.values"
      :key="`${fieldKey}_${value}`"
      class="font-normal pr-3 w-24"
    >
      <PlatformLink
        v-if="fieldKey === 'url'"
        :value="value"
        :feed="getFeedNameByIdx(idx)"
      />
      <div class="text-gray-600" v-else>{{ value || '-' }}</div>
    </th>
  </tr>
</template>

<script>
import PlatformLink from './PlatformLink.vue'

export default {
  name: 'PlatformsTableFields',
  props: {
    fields: Array,
    platforms: Array,
  },
  components: {
    PlatformLink,
  },
  methods: {
    getFeedNameByIdx(idx) {
      return this.platforms[idx].replace(':', '')
    },
  },
}
</script>
